import { render, staticRenderFns } from "./subTable.vue?vue&type=template&id=108a7413&"
import script from "./subTable.vue?vue&type=script&lang=js&"
export * from "./subTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports